import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const getAgentResultsService = async (date) => {
    return (await axiosInstance.get(`${APIROUTE.result}/${date}`)).data;
};

export const getResultsForSingleAgentService = async (date, agentId) => {
    return (await axiosInstance.get(`${APIROUTE.result}/agentId/${agentId}/calculationDate/${date}`)).data;
};

export const updateRemainBalanceService = async  (  payload, agentId ) => {
    return (await axiosInstance.patch(`${APIROUTE.agent}/${agentId}`, payload)).data;
};


